import { useQuery } from '@tanstack/react-query';
import { isSuccess } from '../../common/serviceUtil';
import { useEventStore } from './eventStore';
import { getEvents } from '../../services/sportService';
import { useEventStart } from '../../hooks/eventStart/eventStart';
import { Event } from '../../interfaces/sports';
import { useTranslation } from 'react-i18next';

export const useGetEvents = (eventGroupId?: number, marketCode?: string) => {
  const {
    i18n: { language },
  } = useTranslation();
  const setStore = useEventStore((s) => s.setStore);
  const staleTime = useEventStart();
  return useQuery(
    ['getEvents', eventGroupId],
    ({ signal }) => getEvents({ eventGroupId, signal, marketCode, languageCode: language }),
    {
      refetchOnWindowFocus: false,
      onSettled: (data, error) => {
        if (isSuccess(data)) {
          setStore(data.value);
          return;
        }
      },
      enabled: Boolean(eventGroupId),
      //re-fetch data after this many milliseconds, if 0 don't re-fetch
      refetchInterval: staleTime === 0 ? false : staleTime,
    },
  );
};

/**
 * Retrieve event from the store by event number
 * @param eventNumber
 */
export const useRetrieveByEventNumber = (eventNumber?: number): Event | undefined => {
  const events = useEventStore((s) => s.events);
  const eventMap = useEventStore((s) => s.eventNumberMap);
  if (eventNumber === undefined) return undefined;
  const eventId = eventMap?.get(eventNumber)?.eventId;

  return eventId ? events?.find((event) => event.eventId === eventId) : undefined;
};
